import { API, API_POST } from "../../../Config";


export const handleUpdateService = (payload) => {
    const f = new FormData();
    f.append("name", payload.name)
    f.append("description", payload.description)
    f.append("photo", payload.file)
    f.append("link", payload.link)
    f.append("photo", payload.file)
    f.append("icon", payload.icon)
    f.append("id", payload.id)
    f.append('status',1)
  
    return API_POST(API.EditService, f);
  };